<template>
<div>
  </br>
  <div v-if="!initializing" class="container remove-margins">
        

        <div  class="col-sm-12 col-lg-8 col-md-10 col-xs-12 remove-margins">
          <div class="col-sm-6 col-xs-12 remove-margins">
                <div >
                    <div class="flex-container">
                    <div v-for="photo in petPhotoList">
                        <PetPicView v-bind:photoIdProp="photo.PetPhotoId" :key="photo.PetPhotoId"></PetPicView>
                    </div>
                    </div>
                    <h3 class="text-success"><strong>Step 1: Upload Photo</strong></h3>
                    <div class="image-preview-wrapper">
                        <div class="image-preview">
                             <img id="imgPrev" class="buttonPhoto" :src="photoComp" crossOrigin="Anonymous">
                            <span class="my-button">  
                                            <label class="btn btn-success btn-title">
                                                Photo <i class="fa fa-camera"/> <input id="getImage" style="display: none" class="file" type="file" @change="previewThumbnail" accept="image/jpeg, image/bmp, image/png"/>
                                            </label>
                                </span>
                        </div>
                    </div>
                    
                    <br>
                    <h3 class="text-success"><strong>Step 2: Enter Pet Name</strong></h3>
                    <div class="form-group ">
                                  <div class="inner-addon right-addon">
                                  <i v-show="errors.has('petName')" class="fa fa-warning"></i>
                                  <i v-show="!errors.has('petName')" v-if="newPet.Name"  class="fa fa-paw text-success "></i>
                                  <input type="text" name="petName"  data-vv-as="pet name" v-validate="'required|min:2'" :class="{'input': true, 'has-error': errors.has('petName') }" class="form-control" v-model="newPet.Name" @keyup.enter="validateBeforeSubmit()" placeholder="Pet Name" data-vv-delay="1000">
                                  </div>
                                  <span v-show="errors.has('petName')"  class="help-inline text-danger h5">{{ errors.first('petName') }}</span>
                              </div>
                    <div>
                        <br>
                        <h3 class="text-success"><strong>Step 3: Select Pet Type</strong></h3>
                    <div class="form-group">
                        
                        <div class="row">
                            
                            <div class="col-sm-6 col-xs-6">
                                
                                <button class="btn btn-default btn-title btn-block" style="margin-top:0px; padding-right:0px;" @click="updatePetType(2)"  v-model="newPet.PetType" v-bind:class="{active: newPet.PetType==2, 'btn-danger': !PetTypeSelected}">Cat</button>
                            </div>
                            <div class="col-sm-6 col-xs-6" style="margin-top:0px; padding-left:0px;">
                                    <button class="btn btn-default btn-title btn-block" style="margin-top:0px;margin-right:20px;" @click="updatePetType(1)" v-model="newPet.PetType" v-bind:class="{active: newPet.PetType==1, 'btn-danger': !PetTypeSelected}">Dog</button>
                            </div>
                        </div>  
                        <br>
                        <h3 class="text-success" style="margin-bottom:0px;"><strong>Step 4: Select Pet Gender</strong></h3>
                    <div class="row">
                            <div class="col-sm-6 col-xs-6">
                                <input type="radio" name="male" id="male"   value="true" v-model="newPet.Gender" >
                    <label class="h4" v-bind:class="{'text-danger': !PetGenderSelectedComp}" for="male">Male</label>
                            </div>
                            <div class="col-sm-6 col-xs-6" style="margin-top:0px; padding-left:0px;">
                                    <input type="radio" id="female"  name="female" value="false" v-model="newPet.Gender">
                    <label class="h4" v-bind:class="{'text-danger': !PetGenderSelectedComp}" for="female">Female</label>
                            </div>
                        </div>  
                    
                    <br>
                    <h3 class="text-success" style="margin-bottom:0px;"><strong>Step 5: Specify Age</strong></h3>
                    </div>
                    <div class="form-group">
                        <div class="col-xs-6" style="margin-left:0px !important; padding-left:0px;">
                                <label>Age Years</label>
                               <select required class="form-control input-text"  v-model="newPet.AgeYears">
                                <option value="0" > 0 </option>
                                <option value="1" > 1 </option>
                                <option value="2" > 2 </option>
                                <option value="3" > 3 </option>
                                <option value="4" > 4 </option>
                                <option value="5" > 5 </option>
                                <option value="6" > 6 </option>
                                <option value="7" > 7 </option>
                                <option value="8" > 8 </option>
                                <option value="9" > 9 </option>
                                <option value="10"> 10 </option>
                                <option value="11"> 11 </option>
                                <option value="12"> 12 </option>
                                <option value="13"> 13 </option>
                                <option value="14"> 14 </option>
                                <option value="15"> 15 </option>

                            </select>
                        </div>

                        <div class="col-xs-6" style="margin-left:0px; !important; padding-left:0px;">
                            <label>Age Months</label>
                            <select required class="form-control input-text"  v-model="newPet.AgeMonths">
                                <option value="0" > 0 </option>
                                <option value="1" > 1 </option>
                                <option value="2" > 2 </option>
                                <option value="3" > 3 </option>
                                <option value="4" > 4 </option>
                                <option value="5" > 5 </option>
                                <option value="6" > 6 </option>
                                <option value="7" > 7 </option>
                                <option value="8" > 8 </option>
                                <option value="9" > 9 </option>
                                <option value="10" > 10 </option>
                                <option value="11" > 11 </option>
                                <option value="12" > 12 </option>

                            </select>

                        </div>
                    </div>
                    
                    
                    </div>


            
                </div>
           
          </div>
        
          <div id="petOptional" class="collapse col-sm-12 remove-margins">
          <div class="col-sm-6 col-xs-12 remove-margins" >
             <div>
                <li class="checkbox">
                    <label class="h4">
                            <input type="checkbox" v-model="newPet.IsRegisteredwithColar">
                             Does your pet have Munipicaty Colar and Registration?</label>
                </li>

                <li class="checkbox">
                    <label class="h4">
                            <input type="checkbox" v-model="newPet.IsNeuteredOrSpayed">
                            Is your Pet Neutered/Spayed?</label>
                </li>

                 <li class="checkbox">
                    <label class="h4">
                            <input type="checkbox" v-model="newPet.TicksOrFleas">
                            Is your Pet clean from Ticks and Fleas?</label>
                </li>

                
                 <li class="checkbox">
                    <label class="h4">
                            <input type="checkbox" v-model="newPet.RabiesVaccinated">
                            Has been Rabies Vaccinated?</label>
                </li>

                <div class="form-group">
                <input type="text" class="form-control" placeholder="Microchip ID" v-model="newPet.MicrochipId">
                </div>
                <div class="form-group">
                <input type="text" class="form-control" placeholder="Any preferred Vets in case of an emergency?" v-model="newPet.PreferredVet">
                </div>
                <div class="form-group">
                    <textarea class="form-control" rows="5" v-model="newPet.Remarks" placeholder="Anything the sitter should know about your pet? i.e alergies, medications, surgeries" id="comment"></textarea>
                    </div>
            </div>
         </div>
         </div>
         </div>
            
            <div class="col-sm-6 col-xs-12" style="margin-left:0px; padding-left:0px; margin-right:0px; padding-right:0px;">
                <br>
                <!-- <p><span class="color-green" data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Required to book a pet sitter">★</span> Filling more details about your pet is preferred to ensure sitters are aware of your pet conditions.</p> -->
                <button  class="btn btn-default btn-block" data-toggle="collapse" data-target="#petOptional">
                        Optional Details
                </button>      
               <button v-if="editingMode==false" @click="validateBeforeSubmit()" class="btn btn-success btn-lg btn-block">Save & Continue</button>
                
               <button v-if="editingMode==true" @click="validateUpdate()" class="btn btn-success btn-lg btn-block">Save & Continue</button>
            </div>
      

         

    <div class="container">
      <div class="modal fade" id="cropPetPhotoModal" role="dialog" aria-labelledby="modalLabel" tabindex="-1">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h2 class="modal-title" id="modalLabel"><i class="fa fa-camera"></i> Add Pet Photo</h2>
              
            </div>
            <div class="modal-body row">
              <div class="col-md-6" style="max-width: 400px;max-height: 300px;overflow:hidden">
                <img id="cropPetPhotoCropper" :src="uploadedImageSrcComp" alt="Picture" style="max-width: 100%;max-height: 300px" crossorigin>
                <div v-if="uploading" class="progress progress-image">
                  <div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" :style="{width: uploadCompletePct}" aria-valuemin="0" aria-valuemax="100">
                    <span> {{uploadStatusPct}}</span>
                  </div>
              </div>
              </div>
              <div class="col-md-6 hidden-xs hidden-sm">
                <div class="docs-preview clearfix">
                  <div class="img-preview"></div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button  type="button" @click="saveImage" class="btn btn-title btn-success">Save Image</button>
              <button type="button" @click="cancelSave" class="btn btn-title btn-default" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>

  <div v-else class="container remove-margins">
        <h2>Initializing Pet Data</h2>
        <p>Please refresh your browser if this page takes too long</p>
  </div>

</div>
</div>


  
  
</template>

<script>

const API_URL = "https://www.dupaws.com/services/"
import PetPicView from './PetPicView'
import store from '../../../data/store.js'
import router from '../../../router/index.js'
import loadImage from 'blueimp-load-image'

export default {
    name: 'addPet' , 
    data() {
        return {
           newPet: '',
           saved: false,
           initializing: false,
           PetTypeSelected: true,
           PetGenderSelected: true,
           editingMode: false,
             filePath:'',
        cropOptions:{
                aspectRatio: 5/5,
                background:false,
                autoCropArea: 0.8,
                checkCrossOrigin: true,
                modal: true,
                preview: '.img-preview'
            },
        uploadCompletePct: '',
        uploading: false,
        profilePhoto:{
          Path: '',
          SitterPhotoId: 0,
          Type: ''

        },
        uploadedImageSrc:''
        };
    },
methods:{
    cancelSave: function(){

    },
    previewThumbnail: function(event){
      var orientationVal = true;
      var input = event.target;
      if(input.files&&input.files[0]){
        var self = this;
        self.uploadCompletePct = '';
        var file = input.files[0]


        loadImage.parseMetaData(file, function(data) { // Get the correct orientation setting from the EXIF Data
            if (data.exif) {
                orientationVal = data.exif.get('Orientation');
            }
            else 
                orientationVal = true

                  var loadingImage = loadImage(
              file
          );
        

        loadingImage.onload = function (e){
            var scaledImage = loadImage.scale(
                  loadingImage, // img or canvas element
                  {orientation: orientationVal}
              );
              
            
             var canvas = document.createElement('canvas');
             var ctx = canvas.getContext("2d");

                var maxWidth = 800,
                maxHeight = 800,
                imageWidth = scaledImage.width,
                imageHeight = scaledImage.height;

            if (imageWidth > imageHeight) {
                if (imageWidth > maxWidth) {
                    imageHeight *= maxWidth / imageWidth;
                    imageWidth = maxWidth;
                }
            } else {
                if (imageHeight > maxHeight) {
                    imageWidth *= maxHeight / imageHeight;
                    imageHeight = maxHeight;
                }
            }
            canvas.width = imageWidth;
            canvas.height = imageHeight;
             

            ctx.drawImage(scaledImage, 0, 0, imageWidth, imageHeight);

            // The resized file ready for upload
              var finalFile = canvas.toDataURL("image/png");


            $('#cropPetPhotoModal').modal('show');
            self.uploadedImageSrc = finalFile;
        }
        });
        
        
      
      }
    },
     updatePetType: function(petType){
            this.PetTypeSelected = true
            this.newPet.PetType=parseInt(petType)
     },
     addNewPet: function(){
            var self= this;
            self.initializing = true;
            $.ajax({
                type: 'GET',
                url: API_URL + "api/initPetData",
                beforeSend: function(xhr) {
                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'))
                },
                dataType: "json",
                crossDomain: true,
                contentType: "application/json; charset=utf-8",
                success: function(data) {
                    self.newPet = data  
                    self.newPet.Name ='' //Emptying the recieved data to let customer fill in newPet object fields.
                    self.newPet.Gender =''
                    self.newPet.PetType ='',
                    self.initializing = false
                    
                },
                error: function(data, status, error) {
                    console.log("failed to get pet init data" + data.responseText)
                    swal("Oops", "We had an issue while creating your pet, please refresh your browser to continue", "error")
                    self.initializing = false
                }
            })   
        },
        updatePet: function(){
            var self = this;
            
            console.log(self.newPet)
            if(self.newPet.Name=='' || (self.newPet.AgeYears=='' && self.newPet.AgeMonths==''))
            {
                console.log("Pet data missing")
            } else {
            $.ajax({
                type: 'POST',
                url: API_URL + "api/savePetData",
                data: JSON.stringify(self.newPet),
                beforeSend: function(xhr) {
                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'))
                },
                dataType: "json",
                crossDomain: true,
                contentType: "application/json; charset=utf-8",
                success: function(data) {
                    self.saved=true
                    store.commit('deletePet', self.newPet)   //removing the old entry 
                    store.getters.PetsList.push(data)         //adding the new entry
                    router.push({path: '/pets-view/mypets'})

                },
                error: function(data, status, error) {
                    swal("Error while saving",data.responseText,"error")
                }
            })   
            }
        },
        validateUpdate() {
            var self = this
            this.$validator.validateAll().then((result) => {
                if (result) {
                    if (self.newPet.PetType=='')
                        {
                            swal("Something is missing", "Please select Cat or Dog to continue.", "info")
                            self.PetTypeSelected = false
                            return;
                        }
                        if (self.newPet.Gender=='' && self.newPet.Gender!=false)
                        {
                            swal("Something is missing", "Please choose the correct Gender (Male or Female) to continue.", "info")
                            self.PetGenderSelected = false
                            return;
                        }
                        if (self.newPet.AgeYears==0 && self.newPet.AgeMonths==0)
                        {
                            swal("Something is missing", "Please set the Age Years and Age Months fields.", "info")
                            return;
                        }

                        if (self.petPhotoList.length==0){
                            swal("Photo is missing", "Please upload one or more photos of your pet.", "info")
                            return;
                        }
                    this.updatePet()
                    return;
                    }

                    swal("Something is missing", "Please complete all the required fields to continue.", "info")
                    });
        },
        validateBeforeSubmit() {
            var self = this
            this.$validator.validateAll().then((result) => {
                if (result) {
                    if (self.newPet.PetType=='')
                        {
                            swal("Something is missing", "Please select Cat or Dog to continue.", "info")
                            self.PetTypeSelected = false
                            return;
                        }
                        if (self.newPet.Gender=='' && self.newPet.Gender!=false)
                        {
                            swal("Something is missing", "Please choose the correct Gender (Male or Female) to continue.", "info")
                            self.PetGenderSelected = false
                            return;
                        }
                        if (self.newPet.AgeYears==0 && self.newPet.AgeMonths==0)
                        {
                            swal("Something is missing", "Please set the Age Years and Age Months fields.", "info")
                            return;
                        }

                        if (self.petPhotoList.length==0){
                            swal("Photo is missing", "Please upload one or more photos of your pet.", "info")
                            return;
                        }
                    this.savePet()
                    return;
                    }

                    swal("Something is missing", "Please complete all the required fields to continue.", "info")
                    });
        },
        savePet: function(){
            var self = this;
            
            if(self.newPet.Name=='')
            {
                console.log("Pet data missing")
            } else {
            $.ajax({
                type: 'POST',
                url: API_URL + "api/savePetData",
                data: JSON.stringify(self.newPet),
                beforeSend: function(xhr) {
                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'))
                },
                dataType: "json",
                crossDomain: true,
                contentType: "application/json; charset=utf-8",
                success: function(data) {
                    store.getters.PetsList.push(data)
                    self.saved=true
                       swal({
                        title: "Pet successfully added!",
                        type: "success",
                        confirmButtonClass: 'btn-info',
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        html: true
                        }, function(){
                            if (self.$route.query.sitter)
                            {
                                router.push({path: '/sitter/' + self.$route.query.sitter})    
                            }
                            else
                            {
                                router.push({path: '/pets-view/mypets'})
                            }
                        });
                    
                },
                error: function(data, status, error) {
                    console.log("failed to save Pet" + data.responseText)
                }
            })   
            }
        },
        getPetData: function(){
               var self= this;
                    $.ajax({
                        type: 'GET',
                        url: API_URL + "api/getPetData/" + self.$route.params.petId,
                        beforeSend: function(xhr) {
                            xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'))
                        },
                        dataType: "json",
                        crossDomain: true,
                        contentType: "application/json; charset=utf-8",
                        success: function(data) {
                            
                            self.newPet = data  
                        },
                        error: function(data, status, error) {
                            console.log("failed to get Sitter Location" + data.responseText)
                        }
               })   
        },
        cancel: function(){
            var self = this;
            if(self.saved==false) {
                console.log("Left page without saving Pet")
                $.ajax({
                    type: 'POST',
                    url: API_URL + "api/deletePetData/" + self.newPet.PetId,
                    beforeSend: function(xhr) {
                        xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'))
                    },
                    dataType: "json",
                    crossDomain: true,
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                        
                    },
                    error: function(data, status, error) {
                        console.log("failed to delete Pet" + data.responseText)
                    }
            })   
        }
        },
        saveImage: function(){
              var self = this
              self.uploading = true
              self.uploadCompletePct = '';
              
                $('#cropPetPhotoCropper').cropper('getCroppedCanvas').toBlob(function (blob) {
                    
                    var formData = new FormData();
                    formData.append('image', blob);

                    $.ajax("https://www.dupaws.com/services/api/postPetProfilePhoto/" + self.newPet.PetId, {
                        type: 'POST',
                        data: formData,
                        xhr: function() {  // custom xhr
                            var xhr = new window.XMLHttpRequest();
                            xhr.upload.addEventListener("progress", function (evt) {
                                  if (evt.lengthComputable) {
                                      var percentComplete = evt.loaded / evt.total;
                                      self.uploadCompletePct = (Math.round(percentComplete * 100) + "%")
                                  }
                              }, false);
                              return xhr;
                        },
                        beforeSend: function(xhr){
                            xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                        },
                        crossDomain: true,
                        processData: false,
                        contentType: false,
                        success: function (data) {
                            
                            self.petPhotoList.push(data)
                            self.uploading= false
                            self.uploadedCompletePct = 0
                            $('#cropPetPhotoModal').modal('hide');
                          },
                        error: function () {
                            self.uploading= false
                            self.uploadedCompletePct = 0
                            console.log('Upload error');
                        }
                    });
                   },'image/jpeg', 0.85);
                // $('#cropPetPhotoModal').cropper('destroy');
                // $('#getImage').val('');
        }
    },
    beforeDestroy: function(){
        var self = this;
        if (self.editingMode==false)
            self.cancel()
        
    },
    updated: function(){
         var self=this;
         self.$nextTick(function (){
         $('#cropPetPhotoModal').on('shown.bs.modal', function(){
            $('#cropPetPhotoCropper').cropper(self.cropOptions)
            }).on('hidden.bs.modal',function(){
            $('#cropPetPhotoCropper').cropper('destroy')
        })
         })
     
    },
    mounted: function(){
        var self=this;
        this.$ga.page(this.$router)
        
     
    
        
        
        if (self.$route.params.petId!=null){
            self.editingMode = true;
            self.getPetData()
            }
        else {
            self.addNewPet()
        }
            
        
    },
    components: {
        PetPicView,
        
    },
    computed: {
        uploadStatusPct: function(){
            var self = this
            return 'Uploading image ' + self.uploadCompletePct + ' complete.'
        },
        PetGenderSelectedComp: function(){  //computed to make Gender red if they tried to save without checking it first.
            if (!this.newPet)
                return true
            if (this.PetGenderSelected==true && this.newPet.Gender != '')
                return true
            else if (this.PetGenderSelected==true && this.newPet.Gender =='')
                return true
            else if (this.PetGenderSelected==false && this.newPet.Gender!='')
                return true
            else
                return false
        },
        newPetComp: function(){
            var self=this
            return self.newPet
        },
        photoComp: function(){
             return 'https://www.dupaws.com/services/images/site/addMore.jpg'
        
      },
      petPhotoList: function(){
          var self=this
          if (self.newPet.PetPhotoDtos){
            return self.newPet.PetPhotoDtos
          }
      },
      uploadedImageSrcComp: function(){
          return this.uploadedImageSrc
    }
    }
}

</script>


<style scoped>

/* To fix bootstrap fade using opacity issue*/
.fade {   
    display: none; 
}

.modal {
  text-align: center;
}

@media screen and (min-width: 768px) { 
  .modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

.buttonPhoto{
  width:100%;
  height:100%;
}

.image-preview-wrapper{
  height:100px;
  width:100px;
}

.image-preview {
    position: absolute;
    border: 1px;
    border-style: solid;
    border-color: #e3e3e3;
    width: 100px;
    border-radius: 5px;
    height:100px;
    text-align:center;    
}


.my-button {
    position:relative;
    bottom: 50px;
}


.img-preview {
  background-color: #f7f7f7;
  width: 200px;
  height: 200px;
  text-align: center;
}


.img-preview {
  float: left;
  margin-right: .5rem;
  margin-bottom: .5rem;
  overflow: hidden;
  border: 1px;
  border-radius: 5px;
}


.image-preview .close {
    position: absolute;
    top: 2px;
    right: 2px;
    z-index: 100;
    background-color: #FFF;
    padding: 3px 2px 2px;
    color: #000;
    font-weight: bold;
    cursor: pointer;
    opacity: .2;
    text-align: center;
    font-size: 22px;
    line-height: 10px;
    border-radius: 50%;
}



.my-button:hover {
  opacity: 1;
}


.image-preview:hover .close {
    opacity: 1;
}

.nav-pills > li.active > a, .nav-pills > li.active > a:hover, .nav-pills > li.active > a:focus {
    color: #fff;
    background-color: #78bdf8;
}

/*This only shows the scrollbar when images overflow the width, overflow-y:auto is needed*/

::-webkit-scrollbar {   
    -webkit-appearance: none;
    width: 7px;
}
::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0,0,0,.5);
    -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
}


.flex-container{
    display:flex;
    flex-wrap:nowrap;
    flex-direction:row;
    justify-content: flex-start;
    overflow-x:auto;
}


.progress span {
    position: absolute;
    display: block;
    width: 100%;
    color: #3c3b3b;
 }

.progress-image{
    position:absolute;
    
    width: 80%;
    z-index: 500;
    opacity: 0.9;
    
    top: 50%;
    left: 10%;
}


</style>


// WEBPACK FOOTER //
// PetRegister.vue?64487de3